/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardThreatSummaryMonthResponse {
    getFixupPrototypeFunction() { return SecurityDashboardThreatSummaryMonthResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardThreatSummaryMonthResponse>): SecurityDashboardThreatSummaryMonthResponse {
        let obj = Object.assign(new SecurityDashboardThreatSummaryMonthResponse(), model);
        SecurityDashboardThreatSummaryMonthResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardThreatSummaryMonthResponse>): SecurityDashboardThreatSummaryMonthResponse {
        if (!model) return null;
        return SecurityDashboardThreatSummaryMonthResponse.newInstance(<SecurityDashboardThreatSummaryMonthResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardThreatSummaryMonthResponse) {
        if (!obj) return;

        models.SecurityDashboardThreatSummaryMonthResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardThreatSummaryMonthResponse): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardThreatSummaryMonthResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.summary_by_month) {
            for (let val of this.summary_by_month) {
                models.SecurityDashboardThreatsMonth.fixupPrototype(val);
            }
        }
    }

    /**
     * Visibility of the Threats by Month
     */
    summary_by_month: Array<models.SecurityDashboardThreatsMonth>;

}
